import { computeRealProperties } from "./computeRealProperties.js";
import { setRealProperties } from "./setRealProperties.js";
export function setProperties(bricks, properties, runtimeContext) {
  const realProps = computeRealProperties(properties, runtimeContext);
  if (!Array.isArray(bricks)) {
    bricks = [bricks];
  }
  bricks.forEach(brick => {
    setRealProperties(brick, realProps);
  });
}
//# sourceMappingURL=setProperties.js.map